import React from 'react';
import { Box, Typography, Slider, Button, Paper } from '@mui/material';

interface BudgetStepProps {
  budget: number;
  onBudgetChange: (value: number) => void;
  onNext: () => void;
  onBack: () => void;
}

const marks = [
  { value: 1000, label: '€1.000' },
  { value: 10000, label: '€10.000' },
  { value: 50000, label: '€50.000' },
  { value: 100000, label: '€100.000' },
];

const BudgetStep: React.FC<BudgetStepProps> = ({ budget, onBudgetChange, onNext, onBack }) => {
  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', py: 4 }}>
      <Typography variant="h5" gutterBottom fontWeight={700} textAlign="center">
        Wie viel virtuelles Geld willst du einsetzen?
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 4 }}>
        Wähle ein realistisches Budget. Du kannst es später jederzeit ändern.
      </Typography>

      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h3" textAlign="center" fontWeight={700} color="primary" sx={{ mb: 3 }}>
          €{budget.toLocaleString('de-DE')}
        </Typography>

        <Slider
          value={budget}
          onChange={(_, val) => onBudgetChange(val as number)}
          min={1000}
          max={100000}
          step={1000}
          marks={marks}
          valueLabelDisplay="auto"
          valueLabelFormat={(v) => `€${v.toLocaleString('de-DE')}`}
        />

        <Box sx={{ mt: 2, p: 2, bgcolor: 'info.main', borderRadius: 2, opacity: 0.1 }}>
          <Typography variant="body2" color="text.secondary">
            💡 Tipp: Ein Budget von €10.000 ist ideal zum Lernen — groß genug für verschiedene
            Strategien, klein genug um realistisch zu bleiben.
          </Typography>
        </Box>
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button onClick={onBack}>Zurück</Button>
        <Button variant="contained" onClick={onNext}>Weiter</Button>
      </Box>
    </Box>
  );
};

export default BudgetStep;
